import { IApplicationState } from '../../../types/types';
import { IBoards } from '../boards/types';

export const getBoards = (
    state: IApplicationState
): IBoards => {
    return state.model.dashboards;
};
